<template>
  <div class="toggleButtonContainer" @click="$emit('input', !toCheckData)">
    <div class="switchContainer" :class="toCheckData ? 'backgroundBlue50' : 'backgroundLightGrey50'">
      <div class="switchThumb" :class="toCheckData ? 'transformRight backgroundBlue' : 'backgroundLightGrey'">
        <div class="ripple">
          <!-- <input
            :checked="toCheckData"
            @change="checkInput"
            type="checkbox"
            name="benachrichtigungen"
            :id="`benachrichtigungenCheckbox${index}`"
            :disabled="disabled"
          >-->
        </div>
      </div>
    </div>
    <!-- <label :for="`benachrichtigungenCheckbox${index}`"></label> -->
  </div>
</template>

<script>
export default {
  name: "ToggleButton",
  props: ["toCheck", "index", "disabled"],
  data: function() {
    return {
      toCheckData: this.toCheck
    };
  },
  watch: {
    toCheck: function(newVal, oldVal) {
      // watch for changes => map changes coords
      this.toCheckData = newVal;
    }
  },
  methods: {
    checkInput(e) {
      this.$emit("input", e.target.checked);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.transformRight {
  transform: translate3d(15px, 0, 0);
}
.switchContainer {
  width: 34px;
  min-width: 34px;
  height: 14px;
  margin: 3px 0;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  position: relative;
  border-radius: 14px;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.switchThumb {
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  width: 20px;
  height: 20px;
  position: relative;
  border-radius: 50%;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.switchThumb::before {
  box-sizing: inherit;
  width: 48px;
  height: 48px;
  top: 50%;
  left: 50%;
  z-index: 7;
  content: " ";
  position: absolute;
  transform: translate(-50%, -50%);
}

.ripple {
  width: 48px !important;
  height: 48px !important;
  top: 50% !important;
  left: 50% !important;
  border-radius: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 6;
  overflow: hidden;
  -webkit-mask-image: radial-gradient(circle, #fff 100%, #000 0);
}

label {
  height: 20px;
  padding-left: 16px;
  position: relative;
  line-height: 20px;
}
</style>
